import React, { useState, useEffect } from 'react';

import { useContext } from 'components/Members/Onboarding/Context';

import ProgressBar from 'components/Widgets/ProgressBar';

import IconWithText from 'components/Widgets/IconWithText';

export default function FindingCoach() {
  const { dispatch, state, actions } = useContext();

  const [progress, setProgress] = useState(0);

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: false,
        currentStep: state.currentStep,
      });
    });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 1;
        return next <= 100 ? next : 100;
      });
    }, 100);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      onGoNextClick();
    }
  }, [progress]);

  return (
    <>
      <div className="onboarding-content my-5">
        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
          <ProgressBar now={progress} />
        </div>
      </div>
      <div className="content onboarding-content">
        <div className="text-center" style={{ maxWidth: '600px', margin: '0 auto', paddingTop: '80px' }}>
          <h1>Find Your Perfect Coach</h1>
          <h6 className="text-center mt-3">
            Our experienced coaches bring a wealth of professional expertise, from former
            founders to C-Suite executives, all certified and committed to supporting
            your career, life balance, and leadership journey
          </h6>
        </div>
        <div className="row" style={{ marginTop: '100px', paddingBottom: '100px' }}>
          <div className="col text-center">
            <IconWithText
              iconClassName="big-icon certified-icon bg-secondary"
              wrapperClassName="mb-3 justify-content-center"
              iconStyle={{ minWidth: '120px' }}
            />
            <h6>
              Certified as a
              Professional Coach
            </h6>
          </div>
          <div className="col text-center">
            <IconWithText
              iconClassName="big-icon interviewed-icon bg-secondary"
              wrapperClassName="mb-3 justify-content-center"
              iconStyle={{ minWidth: '120px' }}
            />
            <h6>
              Interviewed, Managed &
              Evaluated by the ICF and LeggUP
            </h6>
          </div>
          <div className="col text-center">
            <IconWithText
              iconClassName="big-icon confidetiality-icon bg-secondary"
              wrapperClassName="mb-3 justify-content-center"
              iconStyle={{ minWidth: '120px' }}
            />
            <h6>
              Strict Member-Coach
              Confidentiality
            </h6>
          </div>
        </div>
      </div>
    </>
  );
}
